import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface MetasPlanCompetenciaPayload {
  id_competencia: number;
  metas: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface MetasPlanCompetencia {
  id?: number;
  id_competencia: number;
  metas: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface MetasPlanCompetenciaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class MetasPlanCompetenciaService {
  private readonly apiUrl = `${environment.apiUrl}/api/metas_plan_competencia`;

  constructor(private http: HttpClient) {}

  // Listar todas las metas del plan de competencia
  getAll(): Observable<MetasPlanCompetencia[]> {
    return this.http.get<MetasPlanCompetencia[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<MetasPlanCompetencia> {
    return this.http.get<MetasPlanCompetencia>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva meta
  create(payload: MetasPlanCompetenciaPayload): Observable<MetasPlanCompetenciaResponse> {
    return this.http.post<MetasPlanCompetenciaResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar meta
  update(id: number, payload: Partial<MetasPlanCompetenciaPayload>): Observable<MetasPlanCompetenciaResponse> {
    return this.http.put<MetasPlanCompetenciaResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar meta (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar meta
  inactivar(id: number): Observable<MetasPlanCompetenciaResponse> {
    return this.http.put<MetasPlanCompetenciaResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar meta
  activar(id: number): Observable<MetasPlanCompetenciaResponse> {
    return this.http.put<MetasPlanCompetenciaResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}
